import { useStores } from "../../../stores/useStores";
import { getQueries } from "../../../utils/SchoolBlocksUtilities";
import { convertMilesToKm } from "../../../utils/DataUtilities";

export function useSchoolFeedContentPathQueryParams() {
  const { organizationStore, userStore, interfaceStore } = useStores();
  const urlQuery = getQueries(interfaceStore.currentFullUrl);
  const q = {};

  if (urlQuery.lat && urlQuery.long && urlQuery.radius) {
    q["lat"] = urlQuery.lat;
    q["long"] = urlQuery.long;
    q["radius"] = convertMilesToKm(Number(urlQuery.radius));
    q["organization__is_live"] = true;

    const orgType = organizationStore.organization.type;
    if (orgType !== "school" && orgType !== "district") {
      q["organization__type"] = orgType;
    }
  } else {
    if (!urlQuery.orgId && !urlQuery.following) {
      q["organization_id"] = organizationStore.organization.id;
    } else if (!urlQuery.following) {
      q["organization_id"] = urlQuery.orgId;
    }
    if (!userStore.editor) {
      q["published"] = true;
    }
    if (urlQuery.following) {
      q["following"] = true;
    }
  }

  return q;
}
